import { Box } from "@mui/system";
import { useRef } from "react";

import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import AppModalTitle from "../../Modals/AppModalTitle";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import RepairSparePartCreateUpdate, {
  RepairSparePartCreateUpdateHandle,
  RepairSparePartCreateUpdateProps,
} from "./RepairSparePartCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: RepairSparePartCreateUpdateProps;
}

export default function RepairSparePartCreateUpdateModal({
  createUpdateProps,
  ...modalProps
}: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.repairSparePartId });
  const formWrapperRef = useRef<RepairSparePartCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} repair spare part
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <RepairSparePartCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
